import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ContinueComponent from "../../toastAlerts/ContinueComponent";

//icons
import { PencilSquare } from "react-bootstrap-icons";
import { BsTrash } from "react-icons/bs";

const AbOfficeCard = ({
    item,
    id,
    handleDeleteAbOffice
}) => {
    const { t } = useTranslation();
    //show contnue
    const [showContinue, setShowContinue] = useState(false);

    return (
        <div className="bg-white rounded-xl p-5 w-full flex flex-col items-center justify-between gap-3 dark:bg-slate-700">
            <div className="w-full flex flex-col gap-2">
                <div className="flex gap-1 flex-wrap">
                    <p className="text-[12px] text-[#989ba5]">{t("admin_warehouse")}:</p>
                    <p className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">{item.country}</p>
                </div>
                <div className="flex gap-1 flex-wrap">
                    <p className="text-[12px] text-[#989ba5]">{t("admin_price")}:</p>
                    <p className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">{item.price}</p>
                </div>
                <div className="flex gap-1 flex-wrap">
                    <p className="text-[12px] text-[#989ba5]">{t("admin_address")}:</p>
                    <p className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">{`${item.town} ${item.state} ${item.adress1}`}</p>
                </div>
                <div className="flex gap-1 flex-wrap">
                    <p className="text-[12px] text-[#989ba5]">{t("admin_address")} 2:</p>
                    <p className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">{`${item.town} ${item.state} ${item.adress2}`}</p>
                </div>
                <div className="flex gap-1 flex-wrap">
                    <p className="text-[12px] text-[#989ba5]">ZIP:</p>
                    <p className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">{item.zip_code}</p>
                </div>
                <div className="flex gap-1 flex-wrap">
                    <p className="text-[12px] text-[#989ba5]">{t("admin_phone")}:</p>
                    <p className="text-[#777a83] font-bold text-[14px] dark:text-gray-200">{item.phone}</p>
                </div>
            </div>
            <div className="w-full flex gap-2">
                <Link to={`../ab-office/${id}`} className="w-full rounded-lg bg-violet-400
                 flex gap-2 items-center justify-center p-1 py-3">
                    <PencilSquare className="text-white font-bold" />
                    <p className="text-white text-sm font-bold">{t("admin_edit")}</p>
                </Link>
                <div
                    onClick={() => { setShowContinue(true) }}
                    className="w-12 rounded-lg bg-red-400 flex items-center justify-center cursor-pointer">
                    <BsTrash className="text-white" />
                </div>
            </div>
            <ContinueComponent
                showFlag={showContinue}
                actionFunction={handleDeleteAbOffice}
                setShowContinue={setShowContinue}
                id={id}
            />
        </div>
    )
}


export default AbOfficeCard;